export default {
  init() {
  },
  finalize() {
    /**
     * Open filter
     */
    $('#events-filter-toggle').on('click', function() {
      $('.walk-listing-walk-listing-filter').addClass('open');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateEvents.js